import type { RoleType } from '@/features/role/domain/enums/RoleType'
import type { CreateUpdateCancelShipmentReasonTranslationEntity } from './CreateUpdateCancelShipmentReasonTranslationEntity'

export class CreateUpdateCancelShipmentReasonEntity {
  role?: RoleType
  translations?: Array<CreateUpdateCancelShipmentReasonTranslationEntity>
}
